<template>
  <div class="tab-common-pick">
    <div class="tab-common-pick__title">
      Select the number of entries
    </div>
    <div class="tab-common-pick__content">
      <div class="tab-common-pick__content-label">
        Entries
      </div>
      <b-dropdown
          :text="textDropdown"
          variant="outline-danger"
          class="tab-common-pick__content-dropdown"
      >
        <b-dropdown-item
            v-for="(item, index) in listNumbers"
            :key="index"
            @click="changeItem(item.number)"
        >
          {{ item.number }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
  // import { lotoNumbers } from '@/resources/loto'
  import lottoService from '@/services/lotto.service';
export default {
  data() {
    return {
      lotoNumbers: [],
      textDropdown: '15',
      listNumbers: [
        { number: '9', active: true },
        { number: '10', active: false },
        { number: '11', active: false },
        { number: '12', active: false },
        { number: '13', active: false },
        { number: '14', active: false },
        { number: '15', active: false }
      ]
    }
  },
  created() {
    this.$store.dispatch('updateTicketType', 'superquick');
    this.$store.dispatch('updateTotalAmount', parseFloat(this.textDropdown));
  },
  methods: {
    changeItem(numberOfTicket) {
      this.textDropdown = numberOfTicket;
      this.lotoNumbers = lottoService.generateTickets(parseInt(numberOfTicket));
      const tickets = Array(parseInt(numberOfTicket)).fill().map((_, index) => index + 1);
      let numbers;
      let numbersRandom;
      tickets.forEach((t, i) => {
        numbers = Array(28).fill().map((_, index) => index + 1);
        numbers.sort(() => Math.random() - 0.5);
        numbersRandom = numbers.slice(0, 7);
        // console.log("numbersRandom", numbersRandom);
        this.lotoNumbers.forEach((item, j) => {
          if (j === i) {
            item.forEach(item => item.active = numbersRandom.includes(item.number) ? true : false)
          }
        })
      });

      this.$store.dispatch('addOrUpdateTickets', this.lotoNumbers);
      this.$store.dispatch('updateTotalAmount', numberOfTicket);
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/loto/tab-common.scss"/>
